import {
  REMOVE_LISTS,
  LOAD_DATA_SILO_STOCK,
  UPDATE_REQUIRE_STOCK,
  LOAD_LOCATION_LISTS,
  GET_DATA_STOCK_DETAIL,
  GET_DATA_STOCK_BALANCE,
  CREATE_STOCK_BALANCE,
  UPDATE_STOCK_BALANCE,
  MATERIAL_STOCK_EXPORT_STOCK_BALANCE,
  MATERIAL_STOCK_GET_DATA_PLANT_SILO_SETTING,
  MATERIAL_STOCK_UPDATE_DATA_PLANT_SILO_SETTING,
} from './actions'

const initialState = {
  data_silo_concrete: [],
  loading_silo_concrete: false,

  loading_location_lists: false,
  location_lists: [],

  loading_raw_mat_usage: false,
  data_raw_mat_usage: [],

  loading_stock_balance: false,
  data_stock_balance: [],

  loading_export_stock_balance: false,
  data_export_stock_balance: [],

  loading_get_data_plant_silo_setting: false,
  data_get_data_plant_silo_setting: [],

  loading_update_data_plant_silo_setting: false,
  data_update_data_plant_silo_setting: [],
}

export default (state = initialState, action) => {
  // console.log(action.type);
  switch (action.type) {
    case REMOVE_LISTS:
      return initialState

    case LOAD_DATA_SILO_STOCK.REQUEST:
      return {
        ...state,
        loading_silo_concrete: false,
        data_silo_concrete: [],
      }

    case LOAD_DATA_SILO_STOCK.SUCCESS:
      return {
        ...state,
        loading_silo_concrete: true,
        data_silo_concrete: action.payload.lists,
      }
    case UPDATE_REQUIRE_STOCK.SUCCESS:
      return {
        ...state,
      }

    case LOAD_LOCATION_LISTS.REQUEST:
      return {
        ...state,
        loading_location_lists: false,
        location_lists: [],
      }

    case LOAD_LOCATION_LISTS.SUCCESS:
      return {
        ...state,
        loading_location_lists: true,
        location_lists: action.payload.lists,
      }

    case GET_DATA_STOCK_DETAIL.REQUEST:
      return {
        ...state,
        loading_raw_mat_usage: false,
        data_raw_mat_usage: [],
      }

    case GET_DATA_STOCK_DETAIL.SUCCESS:
      return {
        ...state,
        loading_raw_mat_usage: true,
        data_raw_mat_usage: action.payload.lists,
      }
    case GET_DATA_STOCK_BALANCE.REQUEST:
      return {
        ...state,
        loading_stock_balance: false,
        data_stock_balance: [],
      }

    case GET_DATA_STOCK_BALANCE.SUCCESS:
      return {
        ...state,
        loading_stock_balance: true,
        data_stock_balance: action.payload.lists,
      }

    case CREATE_STOCK_BALANCE.SUCCESS:
      return {
        ...state,
      }

    case UPDATE_STOCK_BALANCE.SUCCESS:
      return {
        ...state,
      }

    case MATERIAL_STOCK_EXPORT_STOCK_BALANCE.REQUEST:
      return {
        ...state,
        loading_export_stock_balance: true,
        data_export_stock_balance: [],
      }
    case MATERIAL_STOCK_EXPORT_STOCK_BALANCE.SUCCESS:
      return {
        ...state,
        loading_export_stock_balance: false,
        data_export_stock_balance: action.payload.lists,
      }
    case MATERIAL_STOCK_GET_DATA_PLANT_SILO_SETTING.REQUEST:
      return {
        ...state,
        loading_get_data_plant_silo_setting: true,
        data_get_data_plant_silo_setting: [],
      }

    case MATERIAL_STOCK_GET_DATA_PLANT_SILO_SETTING.SUCCESS:
      return {
        ...state,
        loading_get_data_plant_silo_setting: false,
        data_get_data_plant_silo_setting: action.payload.lists,
      }

    case MATERIAL_STOCK_UPDATE_DATA_PLANT_SILO_SETTING.REQUEST:
      return {
        ...state,
        loading_update_data_plant_silo_setting: true,
        data_update_data_plant_silo_setting: [],
      }

    case MATERIAL_STOCK_UPDATE_DATA_PLANT_SILO_SETTING.SUCCESS:
      return {
        ...state,
        loading_update_data_plant_silo_setting: false,
        data_update_data_plant_silo_setting: action.payload.lists,
      }

    default:
      return state
  }
}
